var PageForm = function(sAjaxId, sViewEngine, sSubmitSubView, oDefaultValues, bDoNotFocusOnLoad, bCacheResult) {
   if (!oDefaultValues) {
      oDefaultValue = {};
   }

   function submit(options) {
      var oParams = getQueryParameters();
      var aErrors = formValidator.updateErrors($(sAjaxId));
      if(aErrors.length !== 0) {
         return;
      }
      if (!options) options = {};
      if (bCacheResult) {
         options.cache = bCacheResult;
      }
      options.loadingIndicator = new LoadingIndicator(sAjaxId);
      oParams.submitted = 'true';
      $(sAjaxId).on("portalAjaxLoadEvent", emulateFormBehavior);
      portalAjax.doViewEngineAjax(sSubmitSubView, sViewEngine, $.param(oParams), options);
   }

    function clear() {
        var jForm = $(sAjaxId);
        jForm.find("input").each(function() {
            var jInput = $(this), sType = jInput.attr("type"), sId = jInput.attr("id"), sAlt = jInput.attr("alt"), sDef = oDefaultValue[sId];
            if (!sDef) {
                sDef = sAlt;
            }
            if (sType == "text" || sType == "password" || sType == "number" || sType == "email") {
                if (sDef) {
                    jInput.val(sDef);
                } else {
                    jInput.val("");
                }
            } else if (sType == "radio" || sType == "checkbox") {
                jInput.attr("checked", (sDef ? sDef : false));
            } else if (sType == "button" || sType == "submit" || sType == "hidden") {
            }
        });
        jForm.find("textarea, select").each(function() {
            var jInput = $(this), sId = jInput.attr("id"), sDef = oDefaultValue[sId];
            jInput.val(sDef);
        });
    }

    function emulateFormBehavior() {
      var jForm = $(sAjaxId);
      jForm.unbind("portalAjaxLoadEvent", emulateFormBehavior);
        var bFirst = true;
        jForm.find("input, select").each(function() {
         var jInput = $(this), sType = jInput.attr("type")
         jInput.enter(submit);
            if (bFirst && sType != "hidden") {
               if (!bDoNotFocusOnLoad) {
                  jInput.focus();
               }
               bFirst = false;
            }
        });
    }

    function getQueryParameters() {
        var aParams = {}, jForm = $(sAjaxId);

        jForm.find("input").each(
                function() {
                    var jInput = $(this), sType = jInput.attr("type"), sId = jInput
                            .attr("id");

                    if (sType == "text" || sType == "password" || sType == "number" || 
                    		sType == "email" || sType == "hidden") {
                        aParams[sId] = jInput.val();
                    } else if (sType == "radio") {
                        if (jInput.attr("checked")) {
                            aParams[jInput.attr("name")] = jInput.val();
                        }
                    } else if (sType == "checkbox") {
                        if (jInput.attr("checked")) {
                            aParams[sId] = jInput.val();
                        }
                    } else if (sType == "button" || sType == "submit") {
                        // do nothing
                    }
                });
        jForm.find("textarea, select").each(function() {
            var jInput = $(this), sId = jInput.attr("id");
            aParams[sId] = jInput.val();
        });

        return aParams;
    }

    return {
        getQueryParameters : getQueryParameters,
        submit : submit,
        clear : clear
    };
}
